import useMutationApi from '../../useMutationApi';
import { SupportedGPTModels } from 'src/pages/authenticated/core/spreadsheets/types/spreadsheetTypes';
import type { WorkflowConstants } from 'src/pages/authenticated/core/spreadsheets/types/WorkflowConstants';
// FieldMappings no longer needed for workflow generation

interface WorkflowGenerateWorkflowRequest {
  mappedCsv: string; // Mapped CSV from Phase 2 (post-transformation)
  instructions: string;
  fileNames: string[];
  sheetName: string;
  model?: SupportedGPTModels;
  constants: WorkflowConstants; // Required: must include supplierId, currency
  testMode?: boolean;
}

interface WorkflowStep {
  id?: string;
  type: string;
  description: string;
  inputs?: unknown;
  outputs?: {
    columns?: string[];
    [key: string]: unknown;
  };
  status?: 'success' | 'failed' | 'not_executed';
  error?: string;
}

interface WorkflowGenerateWorkflowResponse {
  success: boolean; // Whether all workflow steps executed successfully
  data: {
    transformedCsv: string;
    workflowSteps: WorkflowStep[];
    rawWorkflowSteps?: WorkflowStep[]; // Raw workflow steps with full inputs
    explanation: string[];
    workflow_executed: string[]; // List of operations that were executed
  };
  error?: string; // Error message if success: false
  failedStepId?: string; // ID of the step that failed (if any)
}

const useWorkflowGenerateWorkflow = () => {
  return useMutationApi<
    WorkflowGenerateWorkflowRequest,
    WorkflowGenerateWorkflowResponse
  >({
    endpoint: 'spreadsheet/workflow/generate-workflow',
    method: 'POST',
    successMessage: 'Workflow generation completed successfully',
    showSuccessToast: false, // Let the UI handle success feedback
  });
};

export default useWorkflowGenerateWorkflow;
export type {
  WorkflowGenerateWorkflowRequest,
  WorkflowGenerateWorkflowResponse,
  WorkflowStep,
};
